if (process.env.NODE_ENV === "production") {
  module.exports = require("./cjs/core.production.min.js")
} else {
  module.exports = require("./cjs/core.development.js")
}



//////////////////
// WEBPACK FOOTER
// ./~/@lingui/core/index.js
// module id = 58
// module chunks = 79611799117203 213534597649335